import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: () => import('@/views/login/index.vue'), hidden: true },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{ path: 'dashboard', component: () => import('@/views/dashboard/index.vue'), name: 'Dashboard', meta: { title: '数据统计', icon: 'el-icon-s-data' } }]
  },
  {
    path: '/user',
    component: Layout,
    meta: { title: '用户管理', icon: 'el-icon-user' },
    children: [{ path: '', component: () => import('@/views/user/index.vue'), name: 'User', meta: { title: '用户管理' } }]
  },
  {
    path: '/merchant',
    component: Layout,
    meta: { title: '商户管理', icon: 'el-icon-s-shop' },
    children: [{ path: '', component: () => import('@/views/merchant/index.vue'), name: 'Merchant', meta: { title: '商户管理' } }]
  },
  {
    path: '/vehicle',
    component: Layout,
    meta: { title: '车辆管理', icon: 'el-icon-bicycle' },
    children: [{ path: '', component: () => import('@/views/vehicle/index.vue'), name: 'Vehicle', meta: { title: '车辆管理' } }]
  },
  {
    path: '/order',
    component: Layout,
    meta: { title: '订单管理', icon: 'el-icon-s-order' },
    children: [{ path: '', component: () => import('@/views/order/index.vue'), name: 'Order', meta: { title: '订单管理' } }]
  },
  {
    path: '/inquiry',
    component: Layout,
    meta: { title: '询价管理', icon: 'el-icon-chat-dot-round' },
    children: [{ path: '', component: () => import('@/views/inquiry/index.vue'), name: 'Inquiry', meta: { title: '询价管理' } }]
  },
  {
    path: '/distribution',
    component: Layout,
    meta: { title: '分销管理', icon: 'el-icon-share' },
    children: [{ path: '', component: () => import('@/views/distribution/index.vue'), name: 'Distribution', meta: { title: '分销管理' } }]
  },
  {
    path: '/finance',
    component: Layout,
    meta: { title: '财务管理', icon: 'el-icon-money' },
    children: [{ path: '', component: () => import('@/views/finance/index.vue'), name: 'Finance', meta: { title: '财务管理' } }]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/admin',
    meta: { title: '系统设置', icon: 'el-icon-setting' },
    children: [
      { path: 'admin', component: () => import('@/views/system/index.vue'), name: 'Admin', meta: { title: '管理员' } },
      { path: 'notice', component: () => import('@/views/notice/index.vue'), name: 'Notice', meta: { title: '公告管理' } },
      { path: 'banner', component: () => import('@/views/banner/index.vue'), name: 'Banner', meta: { title: 'Banner管理' } },
      { path: 'options', component: () => import('@/views/system/options.vue'), name: 'VehicleOptions', meta: { title: '车辆筛选项' } }
    ]
  }
]

const router = new VueRouter({ mode: 'history', base: '/', routes })

router.beforeEach((to, from, next) => {
  const token = store.getters.token
  if (to.path !== '/login' && !token) return next('/login')
  if (to.path === '/login' && token) return next('/')
  next()
})

export default router
